import React, { useEffect, useState } from 'react';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import PreferencesListItem from './PreferencesListItem';
import { ErrorHandler } from '../ErrorHandler';
import { useTranslation } from 'react-i18next';
import PreferencesListSelectBlock from './PreferencesListSelectBlock';
import PreferencesListSelectAssignGroup from './PreferencesListSelectAssignGroup';

const PreferencesList = ({ skipLoad = false }) => {
    const { i18n } = useTranslation();
    const [preferences, setPreferences] = useState(() => [...preferencesStorage.getItems()]);

    const changePreferences = () => {
        setPreferences([...preferencesStorage.getItems()]);
    };

    useEffect(() => {
        if (!skipLoad) {
            preferencesStorage.loadItems(changePreferences);
        } else {
            changePreferences();
        }
        preferencesStorage.registerFiltersChangingObserver(changePreferences);
        return () => {
            preferencesStorage.unRegisterFiltersChangingObserver(changePreferences);
            if (!skipLoad) {
                preferencesStorage.cleanSelectedPreferences();
                preferencesStorage.clearService();
            }
        };
    }, [skipLoad]);

    return (
        preferences.length ?
            <>
                <ul className="preference__list">
                    {preferences.map((preference, index) => (
                        <React.Fragment key={preference.id + index}>
                            <PreferencesListItem preference={preference}/>
                        </React.Fragment>
                    ))}
                </ul>
                <PreferencesListSelectBlock itemsManager={preferencesStorage}>
                    <PreferencesListSelectAssignGroup />
                </PreferencesListSelectBlock>
            </>
            :
            <ErrorHandler isSmall={true} titleValue={i18n.t('app.page.profile.emptyData')} />
    );
};

export default PreferencesList;
